import React from 'react';

const HiddenSpan = ({ text }) => (
  <span className="visuallyhidden">
    {text}
  </span>
);
export default HiddenSpan;
